"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WarningModal = exports.ErrorModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
var _icons = require("@ant-design/icons");
var _Modal = require("./Modal.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 彈窗組件
 */

const Modal = _ref => {
  let {
    closable = true,
    title = "",
    visible,
    confirmLoading,
    okText = "確定",
    cancelText = "取消",
    okButtonProps,
    onOk,
    onCancel,
    footer,
    getContainer = false,
    width = "520px",
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiModal, {
    closable: closable,
    width: width,
    title: title,
    visible: visible,
    confirmLoading: confirmLoading,
    okText: okText,
    cancelText: cancelText,
    okButtonProps: okButtonProps,
    onOk: onOk,
    onCancel: onCancel,
    getContainer: getContainer,
    footer: footer
  }, children);
};
var _default = exports.default = Modal;
Modal.propTypes = {
  closable: _propTypes.default.bool,
  title: _propTypes.default.node,
  visible: _propTypes.default.bool,
  confirmLoading: _propTypes.default.bool,
  okText: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  okButtonProps: _propTypes.default.object,
  onOk: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  footer: _propTypes.default.node,
  getContainer: _propTypes.default.any,
  width: _propTypes.default.string,
  children: _propTypes.default.node
};
const WarningModal = _ref2 => {
  let {
    visible,
    onOk,
    onCancel,
    message = "該名稱已被其他資料使用，確定要儲存？"
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiWaringModal, {
    visible: visible,
    onOk: onOk,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88"), /*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "submit",
      variant: "blue",
      onClick: onOk,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "panorama_fish_eye"),
      full: false
    }, "\u78BA\u5B9A")]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.ExclamationOutlined, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, message)));
};
exports.WarningModal = WarningModal;
WarningModal.propTypes = {
  visible: _propTypes.default.bool,
  onOk: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  message: _propTypes.default.string
};
const ErrorModal = _ref3 => {
  let {
    visible,
    onCancel,
    message = "名稱、作答方式、預設列印方式欄位不得空白"
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiErrorModal, {
    visible: visible,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88")]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, message)));
};
exports.ErrorModal = ErrorModal;
ErrorModal.propTypes = {
  visible: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  message: _propTypes.default.string
};